export default __webpack_public_path__ + "static/media/headerImage.7bdbc1a0.png";